/**
 * Smoothly animates the map from its current zoom to `targetZoom` by stepping
 * one level at a time. Mirrors the behaviour of the dealer-locator widget so the
 * built-in Find a Dealer map zooms with the same feel.
 *
 * Invokes `onDone` once the target zoom is reached (immediately if already there).
 */
export const smoothZoom = (
  map: google.maps.Map,
  targetZoom: number,
  onDone?: () => void
): void => {
  const currentZoom = map.getZoom() ?? 10;

  if (currentZoom === targetZoom) {
    onDone?.();
    return;
  }

  const step = currentZoom < targetZoom ? 1 : -1;
  const nextZoom = currentZoom + step;

  map.setZoom(nextZoom);

  setTimeout(() => {
    if (nextZoom === targetZoom) {
      onDone?.();
    } else {
      smoothZoom(map, targetZoom, onDone);
    }
  }, 50);
};
